module.exports = __webpack_public_path__ + "img/hotjar.0c25861d.jpg";